import { ChickletPrimaryDisplayLabel } from '../../constants/BehaviorTypes';
import ContactChickletPrimaryDisplayLabelRedesign from '../../behaviors/contact/ContactChickletPrimaryDisplayLabelRedesign';
export const Contact = {
  [ChickletPrimaryDisplayLabel]: () => ContactChickletPrimaryDisplayLabelRedesign
};